import ET3Div from "../../../../core/et3-div";
import { withLiteObserverAndTheme } from "../../../../core/et3-enhanced-render";
import BanButton from "../../../../core/et3-shared-components/action-buttons/BanButton";
import SilentBanButton from "../../../../core/et3-shared-components/action-buttons/SilentBanButton";
import TempBanButton from "../../../../core/et3-shared-components/action-buttons/TempBanButton";
import WarningButton from "../../../../core/et3-shared-components/action-buttons/WarningButton";
import { colors } from "../../../../core/et3-theme/colors";
import Et3Margin from "../../../../core/et3-ui/ET3Margin";
import { TCorePage } from "../../../../Types";
import { SILENT_BANNED_FLAG } from "../../../../constants/input-entries-constants";
import { reduce } from "et3-type-guards";

const BanEt3Buttons = withLiteObserverAndTheme<{
  reportID: number;
  reportedID: number;
  reportedIsSilentBanned: number;
  reportedUUID: string;
  pageName: TCorePage;
}>((props) => {
  const {
    reportID,
    pageName,
    reportedID,
    reportedUUID,
    reportedIsSilentBanned
  } = props;
  const shouldHide = pageName === "AUDITOR_AUDIT";
  const isUserSilentBanned =
    reduce(() => reportedIsSilentBanned, 0) === SILENT_BANNED_FLAG;

  return shouldHide ? null : (
    <ET3Div
      isScrollable={false}
      color={colors.all.transparent}
      isExtendable={false}
      fDirection="column"
      justifyContent="center"
      alignItems="center"
      withShadow={false}
      width={200}
      height={205}
      style={{}}
      onClick={() => {}}
    >
      <BanButton
        extraData={{
          reportID,
          reportedID,
          reportedUUID,
          userID: -1,
          userUUID: "",
          secondPartyID: -1
        }}
        fromPage="REPORTS"
        disabled={false}
        size={"MEDIUM"}
      />
      <Et3Margin top={15} bottom={0} right={0} left={0} />
      <TempBanButton
        extraData={{
          reportID,
          reportedID,
          reportedUUID,
          userUUID: "",
          userID: -1,
          secondPartyID: -1
        }}
        fromPage="REPORTS"
        disabled={false}
        size={"MEDIUM"}
      />
      <Et3Margin top={15} bottom={0} right={0} left={0} />
      <SilentBanButton
        extraData={{
          reportID,
          reportedID,
          reportedUUID,
          userUUID: "",
          userID: -1,
          secondPartyID: -1
        }}
        fromPage="REPORTS"
        disabled={isUserSilentBanned}
        size={"MEDIUM"}
      />
      <Et3Margin top={15} bottom={0} right={0} left={0} />
      <WarningButton
        fromPage="REPORTS"
        extraData={{
          reportID,
          reportedID,
          reportedUUID,
          userUUID: "",
          userID: -1,
          secondPartyID: -1
        }}
        disabled={false}
        style={{}}
        size={"MEDIUM"}
      />
    </ET3Div>
  );
});
export default BanEt3Buttons;
